export const Student = {
  NONE: "Немає студентів",
  SINGLE: "студент",
  MANY: "студенти",
  MUCH: "студентів",
};
